document.addEventListener('change', function (event) {
  var selector = event.target.closest('[data-saza-variant-select]');
  if (!selector) return;
  var option = selector.options[selector.selectedIndex];
  var root = selector.closest('[data-saza-product]');
  if (!root || !option) return;
  var price = root.querySelector('[data-saza-price]');
  var compare = root.querySelector('[data-saza-compare]');
  var save = root.querySelector('[data-saza-save]');
  var add = root.querySelector('[data-saza-add]');
  if (price) price.textContent = option.dataset.price;
  if (compare) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
  if (save) { save.textContent = option.dataset.save; save.hidden = !option.dataset.save; }
  if (add) { add.disabled = option.dataset.available !== 'true'; add.textContent = option.dataset.available === 'true' ? add.dataset.addLabel : add.dataset.soldLabel; }
  if (option.dataset.url && window.history && window.history.replaceState) window.history.replaceState({}, '', option.dataset.url);
});
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-saza-quantity]');
  if (!button) return;
  var wrapper = button.closest('.saza-pdp__quantity');
  var input = wrapper && wrapper.querySelector('input');
  if (!input) return;
  var next = Number(input.value || 1) + Number(button.dataset.sazaQuantity);
  input.value = Math.max(1, next);
});
